import React from "react";
import LogoImg from "@assets/img/logo/logo-simple.png";
import { config } from "config";

interface LogoProps {
  imgSize?: "sm" | "md" | "lg" | "xl";
  txtSize?: "sm" | "md" | "lg" | "xl";
  variant?: "color" | "white";
}

const Logo: React.FC<LogoProps> = ({
  imgSize = "md",
  txtSize = "md",
  variant = "color",
}) => {
  const sizes = { sm: 28, md: 36, lg: 48, xl: 72 };
  const textSizes = { sm: "1rem", md: "1.25rem", lg: "1.6rem", xl: "1.85rem" };
  const imgPx = sizes[imgSize];
  const txtPx = textSizes[txtSize];
  const isWhite = variant === "white";

  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{ textDecoration: "none" }}
    >
      {/* Logo */}
      <div
        style={{
          width: imgPx,
          height: imgPx,
          flexShrink: 0,
        }}
      >
        <img
          src={LogoImg}
          alt={config.appName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Wordmark */}
      <span
        style={{
          fontFamily: "'Syne', sans-serif",
          fontWeight: 800,
          fontSize: txtPx,
          color: isWhite ? "#fff" : "var(--text)",
          letterSpacing: "-0.02em",
          lineHeight: 1,
        }}
      >
        {config.appName}
      </span>
    </div>
  );
};

export default Logo;
